<script>
  import options from './ActionResponseBox.options'
  export default options
</script>

<template>

      <div class="kb-action-response-box" 
      :class="{'kb-action-response-box--invisible': visibilityStatusClass}" 
      :style="{'transition': 'all ' + fadeDuration +'ms ease-in-out'}">

        <div   
            class="kb-action-response-box__content"
            aria-live="polite" 
            role="dialog" 
            aria-labelledby="dialog" >
  
            <p class="kb-action-response-box__text" id="dialog">{{ actionResponseText }}</p>
            <div class="kb-action-response-box__triangle" ref="arrow"></div>
  
        </div>

      </div>
   
</template>


